import consignmentApi from '../api/consignment';

export const LOAD_DASHBOARD_CONSIGNMENTS = 'loadDashboardConsignments';
export const FETCH_CONSIGNMENTS = 'fetchConsignments';

const SET_DASHBOARD_CONSIGNMENTS = 'setDashboardConsignments';
const SET_LOADING_DASHBOARD_CONSIGNMENTS = 'setLoadingDashboardConsignments';
const SET_PAGINATED_CONSIGNMENTS = 'setPaginatedConsignments';
const SET_FETCHING_CONSIGNMENTS = 'setFetchingConsignments';

export const DASHBOARD_CONSIGNMENTS = 'dashboardConsignments';
export const CONSIGNMENTS = 'consignments';

export const consignments = {
  state: {
    dashboardConsignments: [],
    loadingDashboardConsignments: false,
    paginatedConsignments: {
      pagination: {},
      data: []
    },
    fetchingConsignments: false
  },
  actions: {
    async loadDashboardConsignments({ commit }) {
      commit(SET_LOADING_DASHBOARD_CONSIGNMENTS, true);

      const dashboardConsignments = await consignmentApi.loadDashboardConsignments();
      if (dashboardConsignments) {
        commit(SET_DASHBOARD_CONSIGNMENTS, dashboardConsignments);
        commit(SET_LOADING_DASHBOARD_CONSIGNMENTS, false);
      }
    },
    async fetchConsignments({ commit }, fields) {
      commit(SET_FETCHING_CONSIGNMENTS, true);

      const data = await consignmentApi.fetchConsignments(fields.page, fields);
      if (data) {
        data.pagination = {
          currentPage: data.meta.current_page,
          lastPage: data.meta.last_page,
          total: data.meta.total
        };
        commit(SET_PAGINATED_CONSIGNMENTS, data);
        commit(SET_FETCHING_CONSIGNMENTS, false);
      }
    }
  },
  mutations: {
    setDashboardConsignments(state, dashboardConsignments) {
      state.dashboardConsignments = dashboardConsignments;
    },
    setLoadingDashboardConsignments(state, loadingDashboardConsignments) {
      state.loadingDashboardConsignments = loadingDashboardConsignments;
    },
    setPaginatedConsignments(state, paginatedConsignments) {
      state.paginatedConsignments = paginatedConsignments;
    },
    setFetchingConsignments(state, fetchingConsignments) {
      state.fetchingConsignments = fetchingConsignments;
    }
  },
  getters: {
    dashboardConsignments(state) {
      return state.dashboardConsignments;
    },
    loadingDashboardConsignments(state) {
      return state.loadingDashboardConsignments;
    },
    paginatedConsignments(state) {
      return state.paginatedConsignments;
    },
    fetchingConsignments(state) {
      return state.fetchingConsignments;
    }
  }
};
